import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const LoadingIcon = styled(FontAwesomeIcon)`
    margin-right: 0.5rem;
    color: ${props => props.theme.primary.interactiveDefault};
`;
